import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ServiceaftaleRabatUpdateDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceaftale-rabat-update-dto';
import { ServiceAftaleService } from 'src/app/api/services';
import { EGIS_SERVICE_CALLER, MAX_INT32_VAL } from 'src/app/constants';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { RabatEditDialogData } from '../../../models';
import { RabatKampagneDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/rabat-kampagne-dto';

@Component({
    selector: 'app-rabat-add-edit',
    templateUrl: './rabat-add-edit.component.html',
    styleUrls: ['./rabat-add-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RabatAddEditComponent implements OnInit {
  rabatForm: UntypedFormGroup;
  isPrivatKunde = false;
  serviceaftaleId: number;
  tabIndex: number;
  maxRabatKontant: number = MAX_INT32_VAL;
  rowVersion: string;
  rabatkampagner: RabatKampagneDto[] = [];

  unsubscribe$ = new Subject<void>();

  get rabatKontant() {
    return this.rabatForm.get('rabatKontant');
  }

  get rabatProcent() {
    return this.rabatForm.get('rabatProcent');
  }

  get rabatTekst() {
    return this.rabatForm.get('rabatTekst');
  }

  get engangsRabat() {
    return this.rabatForm.get('engangsRabat');
  }

  get rabatSplit() {
    return this.rabatForm.get('rabatSplit');
  }

  get rabatkampagne() {
    return this.rabatForm.get('rabatkampagne');
  }

  constructor(
    private fb: UntypedFormBuilder,
    private dialog: MatDialogRef<RabatAddEditComponent>,
    private errorHandler: ErrorHandlerService,
    private serviceAftaleService: ServiceAftaleService,
    @Inject(MAT_DIALOG_DATA) public data: RabatEditDialogData
  ) {
  }

  async ngOnInit(): Promise<void> {
    this.isPrivatKunde = this.data.isPrivatKunde;
    this.serviceaftaleId = this.data.serviceaftaleId;
    this.maxRabatKontant = this.data.maxRabatKontant;
    this.rowVersion = this.data.rowVersion;

    this.rabatForm = this.fb.group({
      rabatKontant: [this.data.rabatKontant, [Validators.min(1), Validators.max(this.maxRabatKontant)]],
      rabatProcent: [this.data.rabatProcent, [Validators.required, Validators.min(1), Validators.max(100)]],
      rabatTekst: [this.data.rabatTekst, [Validators.maxLength(20)]],
      rabatSplit: [this.data.rabatSplit == null ? -1 : this.data.rabatSplit, [Validators.required]],
      engangsRabat: [this.data.engangsRabat],
      rabatkampagne: []
    });
  }

  cancel() {
    this.dialog.close(null);
  }

  save() {
    let update: ServiceaftaleRabatUpdateDto;

    update = {
      id: this.serviceaftaleId,
      customRabat: {
        rabatKontantExclMoms: this.isPrivatKunde ? null : this.rabatKontant.value,
        rabatKontantInklMoms: this.isPrivatKunde ? this.rabatKontant.value : null,
        rabatProcent: this.rabatProcent.value,
        rabatTekst: this.rabatTekst.value,
        partnerShare: (this.rabatSplit.value === -1) ? null : this.rabatSplit.value,
        isEngangsRabat: this.engangsRabat.value
      },
      rabatKampagneId: this.rabatkampagne.value != null ? this.rabatkampagne.value.id : null,
      rowVersion: this.rowVersion
    };

    this.serviceAftaleService
      .updateServiceaftaleRabat({
        caller: EGIS_SERVICE_CALLER,
        body: update
      })
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (response) => {
          this.dialog.close(response.serviceaftale);
        },
        (error: HttpErrorResponse) => {
          this.errorHandler.HandleError(error);
        }
      );
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }
}
